"use client";

import { Capacitor } from "@capacitor/core";
import {
  GoogleAuthProvider,
  signInWithCredential,
} from "firebase/auth";
import { auth } from "@/firebase/config";

export function isNativeFirebaseAuthAvailable() {
  return typeof window !== "undefined" && Capacitor.isNativePlatform();
}

export async function signInWithNativeGoogle() {
  if (!isNativeFirebaseAuthAvailable()) return null;

  const { FirebaseAuthentication } = await import("@capacitor-firebase/authentication");
  const nativeResult = await FirebaseAuthentication.signInWithGoogle();
  const idToken = nativeResult?.credential?.idToken;
  const accessToken = nativeResult?.credential?.accessToken;

  if (!idToken && !accessToken) {
    throw new Error("Native Google sign-in did not return a Firebase credential.");
  }

  const credential = GoogleAuthProvider.credential(idToken || null, accessToken || undefined);
  return await signInWithCredential(auth, credential);
}

export async function signOutNativeFirebase() {
  if (!isNativeFirebaseAuthAvailable()) return;

  try {
    const { FirebaseAuthentication } = await import("@capacitor-firebase/authentication");
    await FirebaseAuthentication.signOut();
  } catch (err) {
    console.warn("Failed to sign out native Firebase auth layer:", err);
  }
}
